import { useEffect, useState } from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import Panel from "../../../components/panel/panel";
import { InputMask } from "primereact/inputmask";
import { Link } from "react-router-dom";

const UserSMS = () => {
  const items = [
    {
      template: () => (
        <Link to={"/reports/userSMS"} className="p-breadcrumb-link">
          Notificações
        </Link>
      ),
    },
  ];
  const home = {
    icon: "fa fa-home",
  };

  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{ background: "transparent", border: "none", fontSize: "16px" }}
        />
      </div>
      <Panel title="Notificar Aplicativo">
        <div className="row d-flex mt-4">
            <div className="inline-flex align-items-center">
              <i className="pi pi-user mr-2"></i>
              <b> Informações Pessoais</b>
            </div>
          <div className="col-md-6 mt-3">
            <span className="p-float-label">
              <InputMask
                // value={cpf}
                // onChange={(e) => setCPF(e.target.value)}
                className="w-100"
                // onChange={(e) => setValue(e.target.value)}
                mask="999.999.999-99"
                placeholder="Digite o CPF"
              />
              <label>CPF *</label>
            </span>
          </div>
          <div className="row">
            <div className="col-md-8 mt-5">
              {/* <label className="h6">Nome completo *</label> */}
              <span className="p-float-label">
                <InputText
                  className="w-100"
                  placeholder="Digite o nome completo"
                  // value={nome}
                  // onChange={(e) => setNome(e.target.value)}
                />
                <label htmlFor="username">Nome Completo *</label>
              </span>
            </div>
            <div className="col-md-4 mt-5">
              <span className="p-float-label">
                <Calendar
                  locale="pt"
                  inputId="start"
                  // value={date}
                  // onChange={(e) => setDate(e.value)}
                />
                <label>Data de Nascimento *</label>
              </span>
            </div>
          </div>

          <div className="row">
            <div className="col-md-5 mt-5">
              <span className="p-float-label">
                <InputText
                  // value={value}
                  className="w-100"
                  placeholder="Digite o RG"
                />
                <label>RG *</label>
              </span>
            </div>
            <div className="col-md-3 mt-5">
              <span className="p-float-label">
                <InputText
                  // value={value}
                  className=" w-100  "
                  placeholder="Ex: SSP"
                />
                <label>Órgão Emissor</label>
              </span>
            </div>
            <div className="col-md-4 mt-5">
              <span className="p-float-label">
                <Calendar
                  inputId="start"
                  locale="pt"
                  // value={date}
                  // onChange={(e) => setDate(e.value)}
                />
                <label>Data de Emissão</label>
              </span>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  );
};

export default UserSMS;
